(function() {
    'use strict';
a3_cabin_reports.factory('CrewAssessmentTemplateFactory', CrewAssessmentTemplateFactory);

/**
* @memberof CabinReports
* @ngdoc factory
* @name CrewAssessmentTemplateFactory
* @description 
*   Get,Set new Crew Assessment Templates
* @ngInject
*/        
function CrewAssessmentTemplateFactory(GenericService){

        /**
        * Initialize the Crew Assessment Template
        * @memberof CrewAssessmentTemplateFactory
        */
		function CrewAssessmentTemplate() {
			this.Id = null;
			this.Description = null;
			this.Label = null;
			this.OrderNo = null;
			this.ItemValue = 3;
			this.GetId = GetId;
		}

		var objType = 'CrewAssessmentTemplate';
		var objCallback = CrewAssessmentTemplate; 
		
		var service = 
		{  
			getCrewAssessmentTemplateFromStorage : getCrewAssessmentTemplateFromStorage,
			setCrewAssessmentTemplateToStorage : setCrewAssessmentTemplateToStorage
		};
			
		//Object services
        /**
         * Overide default get Id
         * @memberof CrewAssessmentTemplateFactory
         * @returns {number} Id 
         */
		function GetId(){
			return this.Id;
		}
		
		// Factory Services
        /**
         * Get Crew Assessment Templates
         * @memberof CrewAssessmentTemplateFactory
         * @returns {Array} CrewAssessmentTemplates 
         */
		function getCrewAssessmentTemplateFromStorage() {
			return GenericService.list(objType,objCallback);
		}

        /**
         * Get Assessment Sync Results
         * @memberof CrewAssessmentTemplateFactory
         * @param {Array} CrewAssessmentTemplates A list of Crew assesment template questions
         */
		function setCrewAssessmentTemplateToStorage(crewAssessmentTemplate) {
			GenericService.saveAll(crewAssessmentTemplate,objType,objCallback);
		}


	return service;
}
	
    
})();